/*
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited 2023.
 */

import { SIGN_IN, GA4_EVENT_SIGN_IN, PAGE_DATA_LAYER } from '@/data/constants/gtm';
import { getGTMSignInEventData } from '@/data/events/data/gtm/SignIn';
import { getGTMConfig } from '@/data/events/handlers/gtm';
import { GTMSignInPayload } from '@/data/types/GTM';
import { error as logError } from '@/data/utils/loggerUtil';
import TagManager from 'react-gtm-module';

export const measure_GA4 = async (data: Awaited<ReturnType<typeof getGTMSignInEventData>>) => {
	const dataLayerName = PAGE_DATA_LAYER;

	const tagManagerArgs = {
		dataLayer: {
			event: GA4_EVENT_SIGN_IN,
			...data,
		},
		dataLayerName,
	};
	TagManager.dataLayer(tagManagerArgs);
};

export const measure_UA = async (data: Awaited<ReturnType<typeof getGTMSignInEventData>>) => {
	const dataLayerName = PAGE_DATA_LAYER;

	const tagManagerArgs = {
		dataLayer: {
			event: SIGN_IN,
			...data,
		},
		dataLayerName,
	};
	TagManager.dataLayer(tagManagerArgs);
};

export const sendGTMSignInEvent = async (payload: GTMSignInPayload) => {
	const { ga4, ua } = getGTMConfig(payload.settings);

	if (ua || ga4) {
		const data = await getGTMSignInEventData(payload);
		if (ua) {
			try {
				await measure_UA(data);
			} catch (error) {
				logError(undefined, 'SignIn: sendGTMSignInEvent: measure_UA: error: %o', error);
			}
		}

		if (ga4) {
			try {
				await measure_GA4(data);
			} catch (error) {
				logError(undefined, 'SignIn: sendGTMSignInEvent: measure_GA4: error: %o', error);
			}
		}
	}
};
